import { render, staticRenderFns } from "./ObraOpenView.vue?vue&type=template&id=36d41d4c"
import script from "./ObraOpenView.vue?vue&type=script&lang=js"
export * from "./ObraOpenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports